import { render, staticRenderFns } from "./ListAdmin.vue?vue&type=template&id=5690a895"
import script from "./ListAdmin.vue?vue&type=script&lang=js"
export * from "./ListAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports